(function () {
  function parseBrandCounts(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var checkboxes = doc.querySelectorAll('input[name="filter.p.m.custom.brand"]');
    var counts = {};

    checkboxes.forEach(function (checkbox) {
      var match = /Metaobject\/(\d+)/.exec(checkbox.value || '');
      if (!match) return;

      var label = checkbox.closest('label');
      var labelText = label ? label.textContent.trim() : '';
      var countMatch = /\((\d+)\)\s*$/.exec(labelText);
      if (!countMatch) return;

      counts[match[1]] = parseInt(countMatch[1], 10);
    });

    return counts;
  }

  function applyCounts(counts) {
    document.querySelectorAll('.brand-menu__item[data-brand-id]').forEach(function (item) {
      var count = counts[item.getAttribute('data-brand-id')];

      if (count === undefined || count === 0) {
        item.hidden = true;
        return;
      }

      var countElement = item.querySelector('.brand-menu__count');
      if (countElement) countElement.textContent = ' (' + count + ')';
    });
  }

  function init() {
    if (!document.querySelector('.brand-menu__item[data-brand-id]')) return;

    fetch('/collections/shop-all-products')
      .then(function (response) {
        return response.ok ? response.text() : null;
      })
      .then(function (html) {
        if (html) applyCounts(parseBrandCounts(html));
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
